/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MinusSquareIcon20Light = forwardRef('MinusSquareIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6 9a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1H6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 2A3.5 3.5 0 0 0 2 5.5v8A3.5 3.5 0 0 0 5.5 17h8a3.5 3.5 0 0 0 3.5-3.5v-8A3.5 3.5 0 0 0 13.5 2h-8ZM3 5.5A2.5 2.5 0 0 1 5.5 3h8A2.5 2.5 0 0 1 16 5.5v8a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 3 13.5v-8Z" })));
});
